import I18n from '../../config/i18n';

import './BreakfastOffer.css';

export default function BreakfastOffer(): JSX.Element {
  return (
    <div className="breakfast-offer">
      <h3>{I18n.t('breakfast_offer.title')}</h3>
      <p dangerouslySetInnerHTML={{ __html: I18n.t('breakfast_offer.body') }} />
    </div>
  );
}
